<script setup lang="ts">
import type { SpecialDetailBannerProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SpecialDetailBannerProps>(), {
  item: null,
  objects: null,
})

const app = useNuxtApp()
const storeIndex = useStoreIndex()

let tMainImg = null // メイン画像
let tMainCaption = null // メイン画像キャプション

// メイン画像情報取得
if (!tMainImg) {
  let tImg = null
  if (props.item.custom.main_image && props.objects) {
    tImg = storeIndex.getImgInfoByID(props.item.custom.main_image, props.objects, 'l')
  }
  if (tImg) {
    tMainImg = tImg
    tMainCaption = app.$getCaption(tImg.description, tImg.referrer)
  } else { // メイン画像が無ければ
    // アイキャッチ情報取得
    const tEyeCatch = storeIndex.getImgInfoByEyeCatch(props.item, (props.item.is_old === 1) ? null : 'l')
    if (tEyeCatch) {
      tMainCaption = app.$getCaption(tEyeCatch.articleObject.description, tEyeCatch.articleObject.referrer)
      tMainImg = tEyeCatch as ArticleObjectWithUrl
    }
  }
}
</script>

<template>
  <div class="l-container">
    <div class="l-container_ui">
      <div class="l-container_ui_header">
        <div
          class="l-container_ui_header_label"
        >
          特集
        </div>
        <div class="l-container_ui_header_content">
          <div
            v-if="item && item.title"
            class="l-container_ui_header_content_title"
          >
            {{ item.title }}
          </div>
        </div>
      </div>

      <div
        v-if="tMainImg"
        class="l-container_ui_imageBox"
      >
        <CommonImage
          class="l-container_ui_imageBox_image"
          v-bind:src="tMainImg.url"
          error-src="/images/noimage.svg"
          object-fit="cover"
        />
      </div>
      <div
        v-if="tMainCaption"
        class="l-container_ui_caption"
      >
        {{ tMainCaption }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.l-container {
  width: 100%;

  &_ui {
    display: flex;
    flex-direction: column;
    width: 100%;

    &_header {
      margin-top: 10px;

      &_label {
        color: var(--color_text_base);
        font-family: "Noto Sans JP", sans-serif;
        font-size: 26px;
        font-weight: 400;

        @include responsive.mq_down(sp) {
          font-size: 20px;
        }
      }

      &_content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 20px 0 4px;

        @include responsive.mq_down(sp) {
          flex: 1;
          margin: 20px 0 4px;
        }

        &_title {
          margin-bottom: 8px;
          color: var(--color_text_base);
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 26px;
          line-height: 1.2;

          @include responsive.mq_down(sp) {
            margin: 0 0 10px;
            font-size: 20px;
            line-height: 1.4;
          }
        }
      }
    }

    &_imageBox {
      width: 100%;
      margin-top: 20px;

      &_image {
        width: 100%;
        height: 406px;
        background-color: #ebebeb;
        object-fit: cover;

        @include responsive.mq_down(sp) {
          height: 48vw;
        }
      }
    }

    &_caption {
      display: flex;
      justify-content: flex-end;
      margin-top: 5px;
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 14px;
      line-height: 2;
    }
  }
}
</style>
